/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_UrlInputs */

const de__field_url = /** @type {(inputs: _Field_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website URL`)
};

/**

* @param {_Field_UrlInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_url = /** @type {((inputs?: _Field_UrlInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_UrlInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_url(inputs)
});